import NotFound from "components/errors/NotFound";
export default NotFound;
